import { ErrorListOutput } from '../../types';

export interface GetBuildingSuccessResponse {
  building: {
    name: string;
    llc: string;
    fullAddress: {
      label: string;
      municipality: string;
      postalCode: string;
      street: string;
      region: string;
    };
    landlord: {
      email: string;
      name: string;
      company: string;
    };
  };
}

export interface GetBuildingErrorResponse {
  building: ErrorListOutput & {
    name: never;
    llc: never;
    fullAddress: never;
    landlord: never;
  };
}

export type GetBuildingResponse =
  | GetBuildingSuccessResponse
  | GetBuildingErrorResponse;

export const GET_BUILDING = (id: string): string => `query {
    building(id: "${id}") {
      ...on BuildingOutput {
        name
        llc
        fullAddress {
          label
          municipality
          postalCode
          street
          region
        }
        landlord {
          email
          name
          company
        }
      }
      ...on ErrorListOutput {
        errors{
          type
          message
        }
      }
    }
  }
`;
